import {fetch} from '../config/axios'
/**
 * 上传文件
 * @param params
 * @returns {boolean|*}
 */
export function uploadFile (params) {
  return fetch(params, '/uploadFile')
}

/**
 * 热搜词
 * @param params
 * @returns {boolean|*}
 */
export function keywordList (params) {
  return fetch(params, '/v2/keywordList')
}

/**
 * 搜索类别
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function searchType (params) {
  return fetch(params, '/v2/searchType')
}
/**
 * 搜索列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function searchListV2 (params) {
  return fetch(params, '/v2/searchList')
}

/**
 * app首页
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function indexInfo (params) {
  return fetch(params, '/v2/indexInfo')
}

/**
 * 首页 拼多多推荐产品
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pddShouYeList (params) {
  return fetch(params, '/v2/pddShouYeList')
}

/**
 * 淘宝 top100
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoTop100 (params) {
  return fetch(params, '/v2/taoTop100')
}

/**
 * 淘宝 一级分类
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoCate1List (params) {
  return fetch(params, '/v2/taoCate1List')
}

/**
 * 淘宝 二级分类
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoCate2List (params) {
  return fetch(params, '/v2/taoCate2List')
}

/**
 * 淘宝 一级分类下商品
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoListByCate1 (params) {
  return fetch(params, '/v2/taoListByCate1')
}

/**
 * 淘宝 二级分类下商品
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoListByCate2 (params) {
  return fetch(params, '/v2/taoListByCate2')
}

/**
 * 淘宝首页
 * @param params
 * @returns {boolean|*}
 */
export function taobaoIndex (params) {
  return fetch(params, '/v2/taobaoIndex')
}

/**
 * 天猫首页
 * @param params
 * @returns {boolean|*}
 */
export function tmallIndex (params) {
  return fetch(params, '/v2/tmallIndex')
}

/**
 * 聚划算首页
 * @param params
 * @returns {boolean|*}
 */
export function juhuasuanIndex (params) {
  return fetch(params, '/v2/juhuasuanIndex')
}

/**
 * 跨境首页
 * @param params
 * @returns {boolean|*}
 */
export function kuajingIndex (params) {
  return fetch(params, '/v2/kuajingIndex')
}



/**
 * 淘宝 商品详情
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoDetail (params) {
  return fetch(params, '/v2/taoDetail')
}

/**
 * 淘宝 猜你喜欢
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoGuess (params) {
  return fetch(params, '/v2/taoGuess')
}

/**
 * 淘宝 优惠券转链
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoGenCouponUrl (params) {
  return fetch(params, '/v2/taoGenCouponUrl')
}

/**
 * 淘宝 生成淘口令
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoGenCommand (params) {
  return fetch(params, '/v2/taoGenCommand')
}

/**
 * 淘宝授权
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function taoOauthByCode (params) {
  return fetch(params, '/v2/taoOauthByCode')
}

/**
 * 京东 首页
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function jdIndex (params) {
  return fetch(params, '/v2/jdIndex')
}
/**
 * 京东 商品详情
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function jdDetail (params) {
  return fetch(params, '/v2/jdDetail')
}

/**
 * 京东 转链
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function jdGenUrl (params) {
  return fetch(params, '/v2/jdGenUrl')
}

/**
 * 京东 分类下商品列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function jdListByCateName (params) {
  return fetch(params, '/v2/jdListByCateName')
}

/**
 * 拼多多 首页
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pddIndex (params) {
  return fetch(params, '/v2/pinduoduoIndex')
}
/**
 * 拼多多 分类下商品
 * @param params
 * @returns {boolean|*}
 */
export function pddListByCateId (params) {
  return fetch(params, '/v2/pddListByCateId')
}

/**
 * 拼多多 商品详情
 * @param params
 * @returns {boolean|*}
 */
export function pddDetail (params) {
  return fetch(params, '/v2/pddDetail')
}

/**
 * 拼多多 优惠券转链
 * @param params
 * @returns {boolean|*}
 */
export function pddGenCouponUrl (params) {
  return fetch(params, '/v2/pddGenCouponUrl')
}

/**
 * 拼多多 热销榜单
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pddRecommend (params) {
  return fetch(params, '/v2/pddRecommend')
}

/**
 * 拼多多 我惠推送
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pddWHPush (params) {
  return fetch(params, '/v2/pddWHPush')
}

/**
 * 拼多多 授权信息
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pddOauthInfo (params) {
  return fetch(params, '/v2/pddOauthInfo')
}

/**
 * 饿了么
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function eleme(params) {
  return fetch(params, '/v2/eleme')
}

/**
 * 美团
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function meituan(params) {
  return fetch(params, '/v2/meituan')
}

/**
 * 京东外卖
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function jdWaiMai(params) {
  return fetch(params, '/v2/jdWaiMai')
}

/**
 * 云店 首页
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydIndex (params) {
  return fetch(params, '/v2/ydIndex')
}
/**
 * 云店-热销产品
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydHotList (params) {
  return fetch(params, '/v2/ydHotList')
}

/**
 * 云店 一级分类下商品
 * @param params
 * @returns {boolean|*}
 */
export function ydListByCate1Id (params) {
  return fetch(params, '/v2/ydListByCate1Id')
}

/**
 * 云店 二级分类下商品
 * @param params
 * @returns {boolean|*}
 */
export function ydListByCate2Id (params) {
  return fetch(params, '/v2/ydListByCate2Id')
}

/**
 * 云店 专区产品
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydZoneList (params) {
  return fetch(params, '/v2/ydZoneList')
}
/**
 * 云店 商品详情
 * @param params
 * @returns {boolean|*}
 */
export function ydDetail (params) {
  return fetch(params, '/v2/ydDetail')
}

/**
 * 云店 商品评论列表
 * @param params
 * @returns {boolean|*}
 */
export function ydEvaluateList (params) {
  return fetch(params, '/v2/ydEvaluateList')
}

/**
 * 厂家 首页
 * @param params
 * @returns {boolean|*}
 */
export function factoryIndex (params) {
  return fetch(params, '/v2/factoryIndex')
}

/**
 * 厂家 收藏/取消收藏
 * @param params
 * @returns {boolean|*}
 */
export function factoryCollect (params) {
  return fetch(params, '/v2/factoryCollect')
}
/**
 * 云店 商品 购物车列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function cartList (params) {
  return fetch(params, '/v2/cartList')
}

/**
 * 云店 商品 加入购物车
 * @param params
 * @returns {boolean|*}
 */
export function cartAdd (params) {
  return fetch(params, '/v2/cartAdd')
}

/**
 * 云店 商品  删除购物车
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function cartDelete (params) {
  return fetch(params, '/v2/cartDelete')
}

/**
 * 云店 商品  编辑购物车
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function cartEdit (params) {
  return fetch(params, '/v2/cartEdit')
}



/**
 * 云店-订单-创建
 * @param params
 * @returns {boolean|*}
 */
export function ydOrderCreate(params) {
  return fetch(params, '/v2/ydOrderCreate', true)
}

/**
 * 云店 获取运费
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function getFreight(params) {
  return fetch(params, '/v2/getFreight', true)
}

/**
 * 云店 订单 列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderList(params) {
  return fetch(params, '/v2/ydOrderList', true)
}
/**
 * 云店 订单 详情
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderDetail(params) {
  return fetch(params, '/v2/ydOrderDetail', true)
}

/**
 * 云店订单-签收
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderSign(params) {
  return fetch(params, '/v2/ydOrderSign', true)
}

/**
 * 云店订单-取消
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderCancel(params) {
  return fetch(params, '/v2/ydOrderCancel', true)
}

/**
 * 云店订单-评价
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderEvaluate(params) {
  return fetch(params, '/v2/ydOrderEvaluate', true)
}

/**
 * 云店订单-原因列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderReasonList(params) {
  return fetch(params, '/v2/ydOrderReasonList', true)
}

/**
 * 云店订单-申请退款
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderRefundApply(params) {
  return fetch(params, '/v2/ydOrderRefundApply', true)
}

/**
 * 云店订单-取消退款
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function ydOrderRefundCancel(params) {
  return fetch(params, '/v2/ydOrderRefundCancel', true)
}

/**
 * 查询物流信息
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function expressInfo(params) {
  return fetch(params, '/v2/expressInfo', true)
}

/**
 * 收货地址-列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressList(params) {
  return fetch(params, '/v2/addressList', true)
}

/**
 * 收货地址-基本信息
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressInfo(params) {
  return fetch(params, '/v2/addressInfo', true)
}

/**
 * 收货地址-添加
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressAdd(params) {
  return fetch(params, '/v2/addressAdd', true)
}

/**
 * 收货地址-编辑
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressEdit(params) {
  return fetch(params, '/v2/addressEdit', true)
}

/**
 * 收货地址-删除
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressDelete(params) {
  return fetch(params, '/v2/addressDelete', true)
}

/**
 * 收货地址-获取默认地址（没有则获取最近添加的地址）
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressGetDefault(params) {
  return fetch(params, '/v2/addressGetDefault', true)
}

/**
 * 收货地址-设置默认地址
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function addressSetDefault(params) {
  return fetch(params, '/v2/addressSetDefault', true)
}



/**
 * 联盟 订单 列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function unionOrderList(params) {
  return fetch(params, '/v2/unionOrderList', true)
}

/**
 * 获取用户基本信息（需登录后）
 * @param params
 * @returns {boolean|*}
 * @constructor
 */
export function ForUserInfo(params) {
  return fetch(params, '/v2/userInfo', true)
}
/**
 * 获取用户基本信息（无需登录）
 * @param params
 * @returns {boolean|*}
 * @constructor
 */
export function ForUserInfo_UnCheck(params) {
  return fetch(params, '/v2/userInfo')
}

/**
 * 根据手机号获取用户Id和昵称
 * @param params
 * @returns {boolean|Promise<unknown>}
 * @constructor
 */
export function ForUserInfoByPhone(params) {
  return fetch(params, '/v2/userInfoByPhone')
}

/**
 * 判断手机号是否已注册
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function phoneCheck(params) {
  return fetch(params, '/v2/phoneCheck')
}

/**
 * 用户登录
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function userLogin(params) {
  return fetch(params, '/v2/userLogin')
}

/**
 * 用户注册
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function userReg(params) {
  return fetch(params, '/v2/userReg')
}

/**
 * 发送短信
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function sendSms(params) {
  return fetch(params, '/v2/sendSms')
}

/**
 * 找回密码
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function findPwd(params) {
  return fetch(params, '/v2/findPwd')
}

/**
 * 手机号换绑
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function phoneChange(params) {
  return fetch(params, '/v2/phoneChange')
}

/**
 * 用户修改头像和昵称
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function userInfoEdit(params) {
  return fetch(params, '/v2/userInfoEdit')
}

/**
 * 修改密码
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function pwdChange(params) {
  return fetch(params, '/v2/pwdChange')
}

/**
 * 设置真实名字
 * @param params
 * @returns {boolean|*}
 */
export function setRealName(params) {
  return fetch(params, '/v2/setRealName')
}

/**
 * 获取邀请二维码和链接
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function invite(params) {
  return fetch(params, '/v2/invite')
}

/**
 * 会员 提现
 * @param params
 * @returns {boolean|Promise<unknown>}
 * @constructor
 */
export function ForWithdrawalsAdd(params) {
  return fetch(params, '/ForWithdrawalsAdd')
}

/**
 * 我惠中心 收入列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 * @constructor
 */
export function ForCardIncomeList(params) {
  return fetch(params, '/ForCardIncomeList')
}


/**
 * 价格配置信息
 * @param params
 * @returns {boolean|Promise<unknown>}
 */
export function priceConfig(params) {
  return fetch(params, '/v2/priceConfig')
}

/**
 * 我惠中心 我的小店 列表
 * @param params
 * @returns {boolean|Promise<unknown>}
 * @constructor
 */
export function ForCFMGoodsList(params) {
  return fetch(params, '/ForCFMGoodsList')
}
export function ForCFMGoodsAdd(params) {
  return fetch(params, '/ForCFMGoodsAdd')
}
export function ForCFMGoodsDelete(params) {
  return fetch(params, '/ForCFMGoodsDelete')
}
export function ForCFMGoodsSetSort(params) {
  return fetch(params, '/ForCFMGoodsSetSort')
}
export function ForCFMGoodsSetTag(params) {
  return fetch(params, '/ForCFMGoodsSetTag')
}
export function ForCFMGoodsSetTop(params) {
  return fetch(params, '/ForCFMGoodsSetTop')
}

/**
 * 判断产品是否上架中
 * state:0 已失效，可替换，1上架中
 * @param params
 * @returns {boolean|*}
 * @constructor
 */
export function goodsIsOn(params) {
  return fetch(params, '/v2/goodsIsOn')
}

export function ForGetMSMGoodsAllList(params) {
  return fetch(params, '/ForGetMSMGoodsAllList')
}

export function ForGetMSMGoodsMyList(params) {
  return fetch(params, '/ForGetMSMGoodsMyList')
}
export function addProxyProduct(params) {
  return fetch(params, '/addProxyProduct')
}

export function ForMSMGoodsChange(params) {
  return fetch(params, '/ForMSMGoodsChange')
}
export function ForGetNFHGoodsAllList(params) {
  return fetch(params, '/ForGetNFHGoodsAllList')
}

export function ForNFHCanXHNum(params) {
  return fetch(params, '/ForNFHCanXHNum')
}
export function ForNFHGoodsAdd(params) {
  return fetch(params, '/ForNFHGoodsAdd')
}
export function ForNFHGoodsChange(params) {
  return fetch(params, '/ForNFHGoodsChange')
}



export function ForRegCardList(params) {
  return fetch(params, '/ForRegCardList')
}
export function recommendShopList(params) {
  return fetch(params, '/recommendShopList')
}
export function collectionShopList(params) {
  return fetch(params, '/collectionShopList')
}
export function ForUserBankAdd(params) {
  return fetch(params, '/ForUserBankAdd')
}

export function ForUserBankList(params) {
  return fetch(params, '/ForUserBankList')
}

export function ForUserBankDelete(params) {
  return fetch(params, '/ForUserBankDelete')
}
export function ForGiftConfig(params) {
  return fetch(params, '/v2/giftConfig')
}
export function ForGiftList(params) {
  return fetch(params, '/v2/giftList')
}
export function ForGiftSureSign(params) {
  return fetch(params, '/v2/giftSureSign')
}
export function ForGiftApply(params) {
  return fetch(params, '/v2/giftApply')
}
export function ForGiftGoGet(params) {
  return fetch(params, '/v2/giftToGet')
}
export function ForPrizeList(params) {
  return fetch(params, '/ForPrizeList')
}
export function ForPrizeApply(params) {
  return fetch(params, '/ForPrizeApply')
}
export function ForPrizeSureSign(params) {
  return fetch(params, '/ForPrizeSureSign')
}
export function ForPrizeToGetBack(params) {
  return fetch(params, '/ForPrizeToGetBack')
}
export function ForPrizeToGetSend(params) {
  return fetch(params, '/ForPrizeToGetSend')
}
export function TravelList(params) {
  return fetch(params, '/TravelList')
}
export function ForSetContact(params) {
  return fetch(params, '/ForSetContact')
}
export function customerList(params) {
  return fetch(params, '/customerList')
}
export function questionList(params) {
  return fetch(params, '/questionList')
}
export function messageaList(params) {
  return fetch(params, '/messageaList')
}
export function delMessage(params) {
  return fetch(params, '/delMessage')
}
export function msgDetail(params) {
  return fetch(params, '/msgDetail')
}
export function feedback(params) {
  return fetch(params, '/feedback')
}
// 我惠学院列表
export function collegeList (params) {
  return fetch(params, '/collegeList')
}
// 留言
export function leaveMessage (params) {
  return fetch(params, '/leaveMessage', true)
}
// 支付方式列表
export function payMethodList(params) {
  return fetch(params, '/payMethodList')
}
// 微信支付
export function wxPay(params) {
  return fetch(params, '/wxPay')
}
// 我惠支付
export function wohuiPay(params) {
  return fetch(params, '/wohuiPay')
}
// 新的绑定上下级,个人中心邀请
export function newbindRelation(params) {
  return fetch(params, '/newbindRelation', true)
}
// 砍一刀系统配置信息接口
export function ForKYDConfig(params) {
  return fetch(params, '/ForKYDConfig', true)
}

// 奖品列表-领取(砍一刀)
export function ForKYDPrizeListToGet(params) {
  return fetch(params, '/ForKYDPrizeListToGet', true)
}

// 奖品列表-今天
export function ForKYDPrizeListToday(params) {
  return fetch(params, '/ForKYDPrizeListToday', true)
}

// 奖品列表-全部
export function ForKYDPrizeList(params) {
  return fetch(params, '/ForKYDPrizeList', true)
}
//去赚钱-任务首页
export function ForTaskInit(params) {
  return fetch(params, '/v2/taskInit',true)
}






// WEBPACK FOOTER //
// ./src/api/commonV2.js